
import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';

import { RowComponentProps } from "react-window";
import { InputWindow } from './InputWindow';
import { SelectWindow } from './SelectCell';
import { useTranslation } from 'react-multi-lang';
import { Checkbox, IconButton } from '@mui/material';
import { Cancel, Delete, Edit, Save } from '@mui/icons-material';

import './winos.scss'


const gridTemplate = `
  minmax(80px, 1fr)
  minmax(90px, 1.15fr)
  minmax(95px, 1.2fr)
  minmax(85px, 1.1fr)
  minmax(80px, 1fr)
  minmax(90px, 1.15fr)
  minmax(100px, 1.35fr)
  minmax(90px, 1.15fr)
  minmax(100px, 1.35fr)
  minmax(80px, 1fr)
  minmax(120px, 2fr)
`;


interface iActions {
  selected: Set<number>,
  setSelected: React.Dispatch<React.SetStateAction<Set<number>>>
  , index?:number, removeLine: (i: number) => void, handleDownload: Function
  , newLine?: boolean
  , editLine: (i: number) => void, enabled?: boolean, saveLine: (i: number) => void
  , isValid: boolean ,id?:number
}

export const Actions = ({ selected
  , setSelected
  , index=0
  , removeLine
  , handleDownload
  , newLine
  , editLine
  , enabled
  , saveLine
  , isValid
  ,id

}: iActions) => {


  return (
    <>{!newLine &&
      <Checkbox
        sx={{
          '& .MuiSvgIcon-root':{
            'width':'20px',
            'height':'20px'
          },
          padding:'0px'
        }}
        className='table_checkbox'
        checked={selected.has(id??-1)}
        onClick={() => setSelected((pre) => {
          
         const new_set = new Set(pre)
         if (id)
           new_set.has(id)?new_set.delete(id):new_set.add(id)
           return new_set
        })}
      />}


      <>
        {removeLine  &&  selected.size ===0&&
          <IconButton onClick={() =>
             removeLine(id??-1)
            }



            sx={{
              padding: '0px',
              transition: 'transform 1s ease',

              '&:hover': {
                transform: 'scale(1);',
                background: 'lightgray',


              }
            }}
          >
            <Delete color="error" sx={{ width: '16px', height: '25px' }} />
          </IconButton>}

        {handleDownload &&
        !enabled&&
        selected.size ===0 &&
        id &&
          <IconButton onClick={() => {
            handleDownload(id)
          }


          }

            sx={{
              padding: '0px',
              transition: 'transform 1s ease',
              width:'20px',


              '&:hover': {
                transform: 'scale(1);',
                background: 'lightgray',


              },
              '& i::before': {
                fontSize: '0.9rem',
                top:'-3px',
                position:'relative'
              }
            }}
          >
            <i className='icon-download-1' style={{ color: "var(--primary-color)", width: '10px', height: '15px' }} />
          </IconButton>}
        {!newLine ?
          editLine &&
          selected.size ===0&&
          <IconButton onClick={() => editLine(index??-1)}

            sx={{
              padding: '0px',
              transition: 'transform 1s ease',

              '&:hover': {
                transform: 'scale(1);',
                background: 'lightgray'

              }
            }}
          >
            {enabled ?
              <Cancel color='warning' sx={{ width: '15px', height: '20px' }} />
              :
              <Edit color='primary' sx={{ width: '15px', height: '20px' }} />
            }
          </IconButton>
          : <span style={{ margin: '0 10px' }}></span>
        }
        {
          !newLine ?
            saveLine && enabled &&
            selected.size ===0&&
            <IconButton
              disabled={!isValid}

              onClick={() => {


                saveLine(index??-1)

              }

              }

              sx={{
                padding: '0px',
                transition: 'transform 1s ease',


                '&:hover': {
                  transform: 'scale(1);',
                  background: 'lightgray'

                }
              }}
            >

              <Save color={isValid ? 'success' : 'disabled'} sx={{ width: '20px', height: '25px' }} />

            </IconButton>
            : <span style={{ marginInline: '' }}></span>
        }

      </>


    </>


  )
}



const handleKeyDown = (event: React.KeyboardEvent) => {
  if (event.key === 'Tab') {
    event.preventDefault(); // Prevent the default Tab behavior

    // Invert the focus direction
    const focusableElements = document.querySelectorAll('.tab_element');
    const focusableArray = Array.from(focusableElements);

    const currentIndex = focusableArray.indexOf(document.activeElement!!);
    const nextIndex =
      currentIndex === 0 && focusableArray ? focusableArray?.length - 1 : currentIndex - 1;

    if (focusableArray[nextIndex].tagName === 'INPUT') {

      (focusableArray[nextIndex] as HTMLInputElement).focus();
    }
    if (focusableArray[nextIndex].tagName === 'SELECT') {
      (focusableArray[nextIndex] as HTMLInputElement).focus();
      (focusableArray[nextIndex] as HTMLSelectElement).click();
    }
  }
};


interface iHeaderRow  {
   selected: Set<number>,
   removeSelected: () => void, handleDownload: Function;

   setSelected:React.Dispatch<React.SetStateAction<Set<number>>>

}

export const HeaderRow = (props:iHeaderRow) => {
  const t = useTranslation()
  
  return (

    <div
     className='windowRow'
      style={{
        display: "grid",
        gridTemplateColumns: gridTemplate,
        fontSize: "clamp(0.85rem, 0.7vw + 0.5rem, 1rem)",
        fontWeight: 500,
        borderBottom: "2px solid #d1d5db",
        lineHeight:1.2,
        zIndex: 10,
        color:' #777'
      }}
    >
      {[
        '',
        t('expense_date'),
        t('expense_type'),
        t('expense_value'),
        t('VAT'),
        t('tax_num'),
        t('expense_mode'),
        t('invoice_num'),

        t('invoice_date'),
        t('invoice_copy'),

        t('notes'),

      ].map((title, i) => (
        <div
          key={i}
          style={{
            padding: "10px",
          
          }}
        >

          {i===0 ?
            
             <>
             {
              props.selected.size>0 &&
               <Checkbox
                  sx={{
                    '& .MuiSvgIcon-root':{
                      'width':'20px',
                      'height':'20px'
                    }
                  }}
                  className='table_checkbox'
                  checked={props.selected.size>0}
                  onClick={() =>props.setSelected(new Set())}
                />
             }
    
       {props.selected.size>0 &&
        <IconButton onClick={() => props.removeSelected()}



            sx={{
              padding: '0px',
              transition: 'transform 1s ease',

              '&:hover': {
                transform: 'scale(1);',
                background: 'lightgray',


              }
            }}
          >
            <Delete color="error" sx={{ width: '16px', height: '22px' }} />
          </IconButton>}

     { props.selected.size>0 &&
      <IconButton onClick={() => {
            props.handleDownload()
          }


          }

            sx={{
              padding: '0px',
              transition: 'transform 1s ease',
              width:'20px',


              '&:hover': {
                transform: 'scale(1);',
                background: 'lightgray',


              },
              '& i::before': {
                fontSize: '1rem',
                top:'-3px',
                position:'relative'
              }
            }}
          >
            <i className='icon-download-1' style={{ color: "var(--primary-color)", width: '10px', height: '15px' }} />
          </IconButton> }  
    
    </>

           :title}
        </div>
      ))}
    </div>
  );
}
export interface singleRowProps extends iActions {
  rows: any[],
  options?: any, handleChange?: (e: React.ChangeEvent, index: number) => void;
   removeNewLine:(i:number)=>void,setFeildValue:(n:string,v:any)=>void , 
   errors:({[k:string]:string}|undefined)[],setFieldError:Function,deleteFieldError:Function

}
export const SingleRow = ({ index
  , style
  , rows
  , options
  , handleChange
  , selected
  , setSelected
  , editLine
  , handleDownload
  , removeLine
  , saveLine
  , isValid
  ,removeNewLine
  ,setFeildValue
  ,errors
  ,setFieldError
  ,deleteFieldError
  
}: RowComponentProps<singleRowProps>) => {
  let values = rows[index]
  let error = errors[index]

  const divStyle = {
    padding: "8px 10px",
    borderRight: "1px solid #e5e7eb",
    overflow: "hidden"
  }

  return (
    <div 
     className="windowRow"
    style={{
      ...style,
      display: "grid",
      gridTemplateColumns: gridTemplate,
      alignItems: "center",
      borderBottom: "1px solid #e5e7eb",
      backgroundColor:  "#ffffff" ,
    fontSize: "clamp(0.65rem, 0.4vw + 0.35rem, 0.8rem)",
     lineHeight:1.2
    }}>
      <div
        style={
          {...divStyle,display:'inline',padding:'5px 7px'}}
      >
        {
          <Actions
            selected={selected}
            setSelected={setSelected}
            index={index}
            id ={values['id']}
            removeLine={values['id']?removeLine:removeNewLine}
            editLine={editLine}
            enabled={values['enabled']}
            handleDownload={handleDownload}
            newLine={values['new_line']}
            saveLine={saveLine}
            isValid={isValid}


          />
        }

      </div>

      <div
        style={divStyle}
      >
        <InputWindow
          value={values['expense_date']}
          filed_name='expense_date'
          input_name={`[${index}][expense_date]`}
          type={'date'}
          msg_err={error? error['expense_date']:''}
          row_number={index}
          not_valid={error ? Boolean(error['exponse_date']):false}
          enabled={values['enabled']}
          index={index}
          handleChange={handleChange}

        />
      </div>
      <div
        style={divStyle}
      >
        <SelectWindow
          value={values['expense_type_id']}
          options={options['expense_type_id']}
          not_valid={error? Boolean(error['expense_type_id']):false}
          disabled={!values['enabled']}
          field_name={'expense_type_id'}
          input_name={`[${index}][expense_type_id]`}
          msg_err={error? error['expense_type_id']:''}
          row_number={index}
          handleChange={handleChange}
        />
      </div>
      <div

        style={divStyle}
      >
        <InputWindow
          value={values['expense_value']}
          filed_name='expense_value'
          input_name={`[${index}][expense_value]`}
          type={'text'}
          msg_err={error?error['expense_value']:''}
          row_number={index}
          not_valid={error?Boolean(error['expense_value']):false}
          enabled={values['enabled']}

          handleChange={handleChange}

        />
      </div>
      <div
        style={divStyle}
      >
        <InputWindow
          value={values['vat']}
          filed_name='vat'
          input_name={`[${index}][vat]`}
          type={'text'}
          msg_err={error?error['vat']:''}
          row_number={index}
          not_valid={error?Boolean(error['vat']):false}
          enabled={values['enabled']}

          handleChange={handleChange}

        />
      </div>
      <div
        style={divStyle}
      >
        <InputWindow
          value={values['tax_num']}
          filed_name='tax_num'
          input_name={`[${index}][tax_num]`}
          type={'text'}
          msg_err={error?error['tax_num']:''}
          row_number={index}
          not_valid={error?Boolean(error['tax_num']):false}
          enabled={values['enabled']}

          handleChange={handleChange}

        />
      </div>
      <div
        style={divStyle}
      >
        <SelectWindow
          value={values['expense_mode_id']}
          options={options['expense_mode_id']}
          not_valid={error?Boolean(error['expense_mode_id']):false}
          disabled={!values['enabled']}
          field_name={'expense_mode_id'}
          input_name={`[${index}][expense_mode_id]`}
          row_number={index}
          handleChange={handleChange}
          msg_err={error?error['expense_mode_id']:''}
        />
      </div>
      <div
        style={divStyle}
      >
        <InputWindow
          value={values['invoice_num']}
          filed_name='invoice_num'
          input_name={`[${index}][invoice_num]`}
          type={'text'}
          msg_err={error?error['invoice_num']:''}
          row_number={index}
          not_valid={error?Boolean(error['invoice_num']):false}
          enabled={values['enabled']}

          handleChange={handleChange}

        />
      </div>
      <div
        style={divStyle}
      >
        <InputWindow
          value={values['invoice_date']}
          filed_name='invoice_date'
          input_name={`[${index}][invoice_date]`}
          type={'date'}
          msg_err={error?error['invoice_date']:''}
          row_number={index}
          not_valid={error?Boolean(error['invoice_date']):false}
          enabled={values['enabled']}

          handleChange={handleChange}

        />
      </div>
      <div
        style={divStyle}
      >
        <InputWindow
          value={values['invoice_copy']}
          filed_name='invoice_copy'
          input_name={`[${index}][invoice_copy]`}
          type={'file'}
          msg_err={error?error['invoice_copy_file']:''}
          row_number={index}
          not_valid={error?Boolean(error['invoice_copy_file']):false}
          enabled={values['enabled']}
         setFieldValue={setFeildValue}
          handleChange={handleChange}
          file_field_name='invoice_copy_file'
          setFieldError={setFieldError}
          deleteFieldError={deleteFieldError}

        />
      </div>
      <div
        style={divStyle}
      >
        <InputWindow
          value={values['notes']}
          filed_name='notes'
          input_name={`[${index}][notes]`}
          type={'note'}
          msg_err={error?error['notes']:''}
          row_number={index}
          not_valid={error?Boolean(error['notes']):false}
          enabled={values['enabled']}

          handleChange={handleChange}

        />
      </div>






    </div>
  )

}